import script from "./index_old.vue?vue&type=script&lang=ts&setup=true"
export * from "./index_old.vue?vue&type=script&lang=ts&setup=true"

import "./index_old.vue?vue&type=style&index=0&id=624418f0&lang=scss&scoped=true"
import "./index_old.vue?vue&type=style&index=1&id=624418f0&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-624418f0"]])

export default __exports__